export default __webpack_public_path__ + "a06e12138143fb0763c3e376f9659dff.png";